import qs from 'query-string';

/**
 * appends a query to an url
 * @param {String} url    the url
 * @param {Object} query  query params to append to the url
 * @param {String} newHash  (optional) an additional fragment to append as hash, will replace any existing hash
 * @returns {String}  the new url with merged params from the query and an encoded hash
 */
const appendQueryString = (url, query, newHash) => {
  const urlHash =
    typeof newHash === 'string' && newHash.length
      ? `#${encodeURIComponent(newHash)}`
      : '';

  if (!query || Object.keys(query).length === 0) {
    return url.split('#')[0] + urlHash;
  }

  const baseUrl = url.split('#')[0].split('?')[0];
  const existingQueryString = url.split('#')[0].split('?')[1];
  const existingQuery = qs.parse(existingQueryString);

  const newQuery = {
    ...existingQuery,
    ...query
  };

  return `${baseUrl}?${qs.stringify(newQuery)}${urlHash}`;
};

export default appendQueryString;
